import React from 'react'
import moment from 'moment'
import { SectionLayoutDialog } from 'shared'

import { ReceiptBlock } from './components'
import { useStyles } from './PaymentReceiptListDialog.style'

const PaymentReceiptListDialog = ({ open, onClose, saleOrder, installments = [] }) => {
  const classes = useStyles()

  const payments = saleOrder?.payments || []

  const installmentOptions = installments
    .map((installment) => ({
      ...installment,
      payments: payments.filter((p) => p.installmentId === installment.id)
    }))
    .filter((x) => x.payments.some((p) => p.hasReceiptFile) || moment().isAfter(x.endDate))
    .sort((a, b) => a.number - b.number)

  return (
    <SectionLayoutDialog
      title='Comprobantes de pago'
      open={open}
      onClose={onClose}
      className={classes.dialog}>
      <div className={classes.container}>
        {installmentOptions.map((installment) => (
          <ReceiptBlock key={installment.id} installment={installment} />
        ))}
      </div>
    </SectionLayoutDialog>
  )
}

export default PaymentReceiptListDialog
